import http from './http';

import * as LocationActions from '../actionTypes/location';
import { getLocationKey } from '../utils/message';

export function addLocationData(key, data) {
    return {
        type: LocationActions.ADD_LOCATION_DATA,
        key,
        data,
    };
}

export function deleteFetchingLocationData(locationKey) {
    return {
        type: LocationActions.DELETE_FETCHING_LOCATION_DATA,
        locationKey,
    };
}

export function setFetchingLocationData(locationKey) {
    return {
        type: LocationActions.SET_FETCHING_LOCATION_DATA,
        locationKey,
    };
}

export function fetchLocationData(message) {
    return (dispatch, getState) => {
        const locationKey = getLocationKey(message.coordinates);

        const {
            config: { appId },
            location: currentlyFetchingLocation,
        } = getState();

        if (currentlyFetchingLocation[locationKey]) {
            return Promise.resolve();
        }

        dispatch(setFetchingLocationData(locationKey));

        return dispatch(
            http('GET', `/apps/${appId}/locationmap`, {
                lat: message.coordinates.lat,
                long: message.coordinates.long,
            }),
        ).then(
            (locationInfo) => {
                dispatch(addLocationData(locationKey, locationInfo));
                dispatch(deleteFetchingLocationData(locationKey));
            },
            () => {
                dispatch(addLocationData(locationKey, { hasError: true }));
                dispatch(deleteFetchingLocationData(locationKey));
            },
        );
    };
}
